export var Filter;
(function (Filter) {
    let Type;
    (function (Type) {
        Type["Discrete"] = "DISCRETE";
        Type["Continuous"] = "CONTINUOUS";
    })(Type = Filter.Type || (Filter.Type = {}));
    let Continuous;
    (function (Continuous) {
        function make(field, conds) {
            const { type } = field;
            switch (type) {
                case "CONTINUOUS": {
                    return { type: "CONTINUOUS", field, conds };
                }
                default: {
                    throw new Error(`Cannot create continuous filter from discrete field`);
                }
            }
        }
        Continuous.make = make;
    })(Continuous = Filter.Continuous || (Filter.Continuous = {}));
    let Discrete;
    (function (Discrete) {
        function make(field, conds) {
            const { type } = field;
            switch (type) {
                case "DISCRETE": {
                    return { type: "DISCRETE", field, conds };
                }
                default: {
                    throw new Error(`Cannot create discrete filter from quantitative attribute`);
                }
            }
        }
        Discrete.make = make;
    })(Discrete = Filter.Discrete || (Filter.Discrete = {}));
})(Filter || (Filter = {}));
